// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

interface ChatHeaderStylesParams {
  isSidePanel?: boolean;
}

const useStyles = createStyles((theme, { isSidePanel }: ChatHeaderStylesParams) => ({
  container: {
    backgroundColor: theme.white,
    borderTopLeftRadius: theme.radius.sm,
    borderTopRightRadius: theme.radius.sm,
    width: 393,
    position: 'relative',
    overflow: 'hidden',
    height: 72,
    flexShrink: 0,

    [theme.fn.smallerThan('md')]: {
      width: '100%',
      ...(!isSidePanel && {
        backgroundColor: theme.colors.gray2[6],
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0,
      }),
    },
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${theme.other.spacing._16}px ${theme.other.spacing._16}px`,
    height: '100%',
    position: 'relative',
  },

  titleSection: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    position: 'relative',
  },

  titleGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._2,
    position: 'relative',
  },

  titleWithDot: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._6,
  },

  title: {
    color: theme.colors.gray2[6],
    fontSize: 16,
    fontWeight: 900,
    lineHeight: '24px',

    [theme.fn.smallerThan('md')]: {
      ...(!isSidePanel && {
        color: theme.white,
      }),
    },
  },

  orangeDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.colors.orange[4],
    flexShrink: 0,
  },

  subtitle: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },

  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._8,
  },

  titleClickable: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._2,
    cursor: 'pointer',
  },

  mobileCloseButton: {
    backgroundColor: theme.colors.gray2[5],
    borderRadius: '100em',
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  sidePanelCloseButton: {
    borderRadius: theme.radius.xl,
  },
}));

export default useStyles;
